import React from 'react';
import { Fragment } from 'react'
import { Icon } from '@iconify/react';
import { useApi } from '../../context/apiContext';
import Modal from 'react-bootstrap/Modal';

export default function ModalTiendaCerrada({ showModalTiendaCerrada, setShowModalTiendaCerrada }) {

    const { getTextByKey } = useApi();

    const handleClose = () => {
        setShowModalTiendaCerrada(false);
    }

    return (
        <Fragment>
            <Modal className="modal-compra" show={showModalTiendaCerrada} onHide={handleClose} centered>
                <Modal.Body>
                    <div className="text-end pe-2 icon-close">
                      <Icon className='cursor-pointer gray-color' icon="bi:x-lg" onClick={handleClose}></Icon>
                    </div>
                    <div className="content-opt d-md-flex justify-content-center d-block py-4">

                      <div className="container pt-5 text-center">
                        <h2 className="primary-color carrefourMetis-bold">{getTextByKey('modal-tienda-cerrada-titulo')}</h2>
                        {/* <h3 className="gray-1-color mb-4"></h3> */}
                        
                        <div class="text-center pt-3">
                          <p class="gray-1-color cursor-pointer mb-0">{getTextByKey('modal-tienda-cerrada')}</p>
                        </div>
                    </div>

                    </div>
                    <div className="text-center d-flex justify-content-center align-items-center">
                      <button className='btn-g bb px-4' onClick={handleClose}>{getTextByKey('volver')}</button>
                    </div>
                </Modal.Body>
            </Modal>
        </Fragment>
    )
}
